// extracted by mini-css-extract-plugin
export var bounce = "_pc-1";
export var generatingText = "_pc-6";
export var lightning = "_pc-4";
export var popup = "_pc-5";
export var progressBar = "_pc-7";
export var progressFill = "_pc-8";
export var progressShimmer = "_pc-9";
export var progressText = "_pc-a";
export var shimmer = "_pc-3";
export var uploadIcon = "_pc-0";
export var uploadingText = "_pc-2";